import { useQuery, useQueryClient } from '@tanstack/react-query'
import { GETSystemCatalogCategories } from '../queries'

function useGetSystemCatalogCategories() {
  const queryClient = useQueryClient()
  const queryKey = ['system_catalog_categories']

  const query = useQuery({
    queryFn: async () => await GETSystemCatalogCategories(),
    queryKey: queryKey,
    refetchOnMount: 'always',
  })

  const invalidateQuery = () => {
    return queryClient.invalidateQueries({ queryKey: queryKey })
  }

  return {
    query,
    invalidateQuery,
  }
}

export default useGetSystemCatalogCategories
